import { Facebook, Instagram, LinkedIn, Pinterest, Twitter, WhatsApp, YouTube } from "@mui/icons-material";



const domains = {
    'sagasystems.com.br': 'brazil',
    'sagasystemschile.com': 'chile'
}

const customData = {
    country: domains[window.location.host] ?? 'brazil',

    brazil: {
        showStore: true,
        showTechnicalSupport: true,
        language: 'pt_br',
        phones: [
            {
                label: '(11) 3225-0908',
                link: 'tel:1132250908',
                Icon: null,
                showFooter: true
            },
            {
                label: '(11) 95898-5880 ({sulfix})',
                sulfix: 'store',
                link: 'https://wa.me/5511958985880',
                Icon: WhatsApp,
                showFooter: false
            },
            {
                label: '(11) 98694-0275 ({sulfix})',
                sulfix: 'afterSales',
                link: 'https://wa.me/5511986940275',
                Icon: WhatsApp,
                showFooter: false
            },
            {
                label: '(11) 95371-0007 ({sulfix})',
                sulfix: 'afterSales',
                link: 'https://wa.me/5511953710007',
                Icon: WhatsApp,
                showFooter: false
            },
        ],
        emails: [
            {
                link: 'saga@sagasystems.com.br',
                showFooter: true,
            },
            {
                link: 'ouvidoria@sagasystems.com.br',
                showFooter: true,
            },
        ],
        address: {
            street: {
                pt_br: 'Praça da República, 386 - 5º Cj 53',
                en_us: '386, Republic square - 5º Cj 53',
                es_es: 'Plaza de la república, 386 - 5º Cj 53'
            },
            city: 'São Paulo/SP',
            zipCode: '01045-000',
            googleMaps: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1026.4110798530396!2d-46.64206941261307!3d-23.542812493149224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMyJzMzLjYiUyA0NsKwMzgnMjkuMiJX!5e0!3m2!1spt-BR!2sbr!4v1712603726185!5m2!1spt-BR!2sbr"
        },
    },

    chile: {
        showStore: false,
        showTechnicalSupport: true,
        language: 'es_es',
        phones: [
            {
                label: '98272-8539 ({sulfix})',
                sulfix: 'management',
                link: 'https://wa.me/56982728539',
                Icon: WhatsApp,
                showFooter: true
            }, {
                label: '97394-3286 ({sulfix})',
                sulfix: 'salesAndServices',
                link: 'https://wa.me/56973943286',
                Icon: WhatsApp,
                showFooter: true
            }, {
                label: '95226-2223 ({sulfix})',
                sulfix: 'technicalAssistance',
                link: 'https://wa.me/56952262223',
                Icon: WhatsApp,
                showFooter: true
            }, {
                label: '+55 11 3225-0908 ({sulfix})',
                sulfix: 'brazil',
                link: 'tel:+551132250908',
                Icon: null,
                showFooter: true
            }
        ],
        emails: [
            {
                link: 'gerencia@sagasystemschile.com',
                showFooter: true,
            },
            {
                link: 'ventasyservicio@sagasystemschile.com',
                showFooter: true,
            },
            {
                link: 'serviciotecnico@sagasystemschile.com',
                showFooter: true,
            }
        ],
        address: {
            street: {
                pt_br: 'Rua Moneda, 645',
                en_us: '645, Moneda street',
                es_es: 'Calle Moneda, 645'
            },
            city: 'Santiago (Chile)',
            zipCode: '8320215',
            googleMaps: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d832.326457670497!2d-70.646365561413!3d-33.44133782337293!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c5a1d939849d%3A0x579a47bdf5f51e8!2sMoneda%20645%2C%208320215%20Santiago%2C%20Regi%C3%B3n%20Metropolitana%2C%20Chile!5e0!3m2!1spt-BR!2sbr!4v1775845991423!5m2!1spt-BR!2sbr"
        },
    }
}


console.log(window.location.host, customData);


const DefaultConstants = {
    baseUrl: process.env.REACT_APP_BASE_URL || '',
    systemName: 'Saga Systems',
    developer: {
        name: 'NexTech Solutions',
        url: 'https://www.linkedin.com/in/reginaldo-savian-jr-045820141/'
    },
    country: customData.country,
    ...customData[customData.country],
    catalog: {
        url: 'https://online.fliphtml5.com/rsatm/khaj/',
        title: 'sagasystems-catalog'
    },
    home: {
        slides: [
            {
                background: '/assets/images/home/1.png',
                text: {
                    title: 'homeWallpaper1Description',
                    message: undefined
                },
                align: 'center',
                button: undefined
            }, {
                background: '/assets/images/home/2.png',
                text: {
                    title: 'electronicLocks',
                    message: 'homeWallpaper2Description'
                },
                align: 'left',
                button: {
                    text: 'seeProducts',
                    link: '/products/electronicLocks',
                    internal: true
                }
            }, {
                background: '/assets/images/home/3.png',
                text: {
                    title: 'electronicSafes',
                    message: 'homeWallpaper3Description'
                },
                align: 'left',
                button: {
                    text: 'seeProducts',
                    link: '/products/electronicSafes',
                    internal: true
                }
            }, {
                background: '/assets/images/home/4.png',
                text: {
                    title: 'energySavers',
                    message: 'homeWallpaper4Description'
                },
                align: 'left',
                button: {
                    text: 'seeProducts',
                    link: '/products/energySavers',
                    internal: true
                }
            }
        ]
    },
    products: {
        title: 'products',
        subtitle: 'productsSubtitle',
        description: 'productsDescription',
        wallpaper: '/assets/images/products/wallpaper.png',
        items: [
            {
                name: 'electronicLocks',
                icon: '/assets/images/products/electronicLocks/icon.png',
                image: '/assets/images/products/electronicLocks/wallpaper.png',
                description: 'electronicLocksDescription',
                homeDescription: 'electronicLocksHomeDescription',
                products: [
                    {
                        id: '1',
                        name: 'electronicLock1',
                        wallpaper: '/assets/images/products/electronicLocks/1_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicLocks/1_1.png',
                                '/assets/images/products/electronicLocks/1_2.png',
                                '/assets/images/products/electronicLocks/1_3.png',
                                '/assets/images/products/electronicLocks/1_4.png',
                                '/assets/images/products/electronicLocks/1_5.png',
                                '/assets/images/products/electronicLocks/1_6.png',
                                '/assets/images/products/electronicLocks/1_7.png',
                                '/assets/images/products/electronicLocks/1_8.png',
                                '/assets/images/products/electronicLocks/1_9.png',
                                '/assets/images/products/electronicLocks/1_10.png',
                                '/assets/images/products/electronicLocks/1_11.png',
                                '/assets/images/products/electronicLocks/1_12.png',
                            ],
                            en_us: [
                                '/assets/images/products/electronicLocks/1_1.png',
                                '/assets/images/products/electronicLocks/1_2.png',
                                '/assets/images/products/electronicLocks/1_3.png',
                                '/assets/images/products/electronicLocks/1_4.png',
                                '/assets/images/products/electronicLocks/1_5.png',
                                '/assets/images/products/electronicLocks/1_6.png',
                                '/assets/images/products/electronicLocks/1_7.png',
                                '/assets/images/products/electronicLocks/1_8.png',
                                '/assets/images/products/electronicLocks/1_9.png',
                                '/assets/images/products/electronicLocks/1_10.png',
                                '/assets/images/products/electronicLocks/1_11.png',
                                '/assets/images/products/electronicLocks/1_12.png',
                            ],
                            es_es: [
                                '/assets/images/products/electronicLocks/1_1.png',
                                '/assets/images/products/electronicLocks/1_2.png',
                                '/assets/images/products/electronicLocks/1_3.png',
                                '/assets/images/products/electronicLocks/1_4.png',
                                '/assets/images/products/electronicLocks/1_5.png',
                                '/assets/images/products/electronicLocks/1_6.png',
                                '/assets/images/products/electronicLocks/1_7.png',
                                '/assets/images/products/electronicLocks/1_8.png',
                                '/assets/images/products/electronicLocks/1_9.png',
                                '/assets/images/products/electronicLocks/1_10.png',
                                '/assets/images/products/electronicLocks/1_11.png',
                                '/assets/images/products/electronicLocks/1_12.png',
                            ]
                        },
                        description: 'electronicLock1Description',
                    }, {
                        id: '2',
                        name: 'electronicLock2',
                        wallpaper: '/assets/images/products/electronicLocks/2_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicLocks/2_1.png',
                                '/assets/images/products/electronicLocks/2_2.png',
                                '/assets/images/products/electronicLocks/2_3.png',
                                '/assets/images/products/electronicLocks/2_4.png',
                                '/assets/images/products/electronicLocks/2_5.png',
                                '/assets/images/products/electronicLocks/2_6.png',
                                '/assets/images/products/electronicLocks/2_7.png',
                                '/assets/images/products/electronicLocks/2_8.png',
                                '/assets/images/products/electronicLocks/2_9.png',
                                '/assets/images/products/electronicLocks/2_10.png',
                                '/assets/images/products/electronicLocks/2_11.png',
                                '/assets/images/products/electronicLocks/2_12.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicLocks/2_1.png',
                                '/assets/images/products/electronicLocks/2_2.png',
                                '/assets/images/products/electronicLocks/2_3.png',
                                '/assets/images/products/electronicLocks/2_4.png',
                                '/assets/images/products/electronicLocks/2_5.png',
                                '/assets/images/products/electronicLocks/2_6.png',
                                '/assets/images/products/electronicLocks/2_7.png',
                                '/assets/images/products/electronicLocks/2_8.png',
                                '/assets/images/products/electronicLocks/2_9.png',
                                '/assets/images/products/electronicLocks/2_10.png',
                                '/assets/images/products/electronicLocks/2_11.png',
                                '/assets/images/products/electronicLocks/2_12.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicLocks/2_1.png',
                                '/assets/images/products/electronicLocks/2_2.png',
                                '/assets/images/products/electronicLocks/2_3.png',
                                '/assets/images/products/electronicLocks/2_4.png',
                                '/assets/images/products/electronicLocks/2_5.png',
                                '/assets/images/products/electronicLocks/2_6.png',
                                '/assets/images/products/electronicLocks/2_7.png',
                                '/assets/images/products/electronicLocks/2_8.png',
                                '/assets/images/products/electronicLocks/2_9.png',
                                '/assets/images/products/electronicLocks/2_10.png',
                                '/assets/images/products/electronicLocks/2_11.png',
                                '/assets/images/products/electronicLocks/2_12.png'
                            ]
                        },
                        description: 'electronicLock2Description',
                    }, {
                        id: '3',
                        name: 'electronicLock3',
                        wallpaper: '/assets/images/products/electronicLocks/3_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicLocks/3_1.png',
                                '/assets/images/products/electronicLocks/3_2.png',
                                '/assets/images/products/electronicLocks/3_3.png',
                                '/assets/images/products/electronicLocks/3_4.png',
                                '/assets/images/products/electronicLocks/3_5.png',
                                '/assets/images/products/electronicLocks/3_6.png',
                                '/assets/images/products/electronicLocks/3_7.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicLocks/3_1.png',
                                '/assets/images/products/electronicLocks/3_2.png',
                                '/assets/images/products/electronicLocks/3_3.png',
                                '/assets/images/products/electronicLocks/3_4.png',
                                '/assets/images/products/electronicLocks/3_5.png',
                                '/assets/images/products/electronicLocks/3_6.png',
                                '/assets/images/products/electronicLocks/3_7.png'
                            ], 
                            es_es: [
                                '/assets/images/products/electronicLocks/3_1.png',
                                '/assets/images/products/electronicLocks/3_2.png',
                                '/assets/images/products/electronicLocks/3_3.png',
                                '/assets/images/products/electronicLocks/3_4.png',
                                '/assets/images/products/electronicLocks/3_5.png',
                                '/assets/images/products/electronicLocks/3_6.png',
                                '/assets/images/products/electronicLocks/3_7.png'
                            ]
                        },
                        description: 'electronicLock3Description',
                    }, {
                        id: '4',
                        name: 'electronicLock4',
                        wallpaper: '/assets/images/products/electronicLocks/4_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicLocks/4_1.png',
                                '/assets/images/products/electronicLocks/4_2.png',
                                '/assets/images/products/electronicLocks/4_3.png',
                                '/assets/images/products/electronicLocks/4_4.png',
                                '/assets/images/products/electronicLocks/4_5.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicLocks/4_1.png',
                                '/assets/images/products/electronicLocks/4_2.png',
                                '/assets/images/products/electronicLocks/4_3.png',
                                '/assets/images/products/electronicLocks/4_4.png',
                                '/assets/images/products/electronicLocks/4_5.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicLocks/4_1.png',
                                '/assets/images/products/electronicLocks/4_2.png',
                                '/assets/images/products/electronicLocks/4_3.png',
                                '/assets/images/products/electronicLocks/4_4.png',
                                '/assets/images/products/electronicLocks/4_5.png'
                            ]
                        },
                        description: 'electronicLock4Description',
                    }, {
                        id: '5',
                        name: 'electronicLock5',
                        wallpaper: '/assets/images/products/electronicLocks/5_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicLocks/5_1.png',
                                '/assets/images/products/electronicLocks/5_2.png',
                                '/assets/images/products/electronicLocks/5_3.png',
                                '/assets/images/products/electronicLocks/5_4.png',
                                '/assets/images/products/electronicLocks/5_5.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicLocks/5_1.png',
                                '/assets/images/products/electronicLocks/5_2.png',
                                '/assets/images/products/electronicLocks/5_3.png',
                                '/assets/images/products/electronicLocks/5_4.png',
                                '/assets/images/products/electronicLocks/5_5.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicLocks/5_1.png',
                                '/assets/images/products/electronicLocks/5_2.png',
                                '/assets/images/products/electronicLocks/5_3.png',
                                '/assets/images/products/electronicLocks/5_4.png',
                                '/assets/images/products/electronicLocks/5_5.png'
                            ]
                        },
                        description: 'electronicLock5Description',
                    }, {
                        id: '6',
                        name: 'electronicLock6',
                        wallpaper: '/assets/images/products/electronicLocks/6_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicLocks/6_1.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicLocks/6_1.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicLocks/6_1.png'
                            ]
                        },
                        description: 'electronicLock6Description',
                    },
                ]
            }, {
                name: 'electronicSafes',
                icon: '/assets/images/products/electronicSafes/icon.png',
                image: '/assets/images/products/electronicSafes/wallpaper.png',
                description: 'electronicSafesDescription',
                homeDescription: 'electronicSafesHomeDescription',
                products: [
                    {
                        id: '1',
                        name: 'electronicSafe1',
                        wallpaper: '/assets/images/products/electronicSafes/1_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicSafes/1_1.png',
                                '/assets/images/products/electronicSafes/1_2.png',
                                '/assets/images/products/electronicSafes/1_3.png',
                                '/assets/images/products/electronicSafes/1_4.png',
                                '/assets/images/products/electronicSafes/1_5.png',
                                '/assets/images/products/electronicSafes/1_6.png',
                                '/assets/images/products/electronicSafes/1_7.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicSafes/1_1.png',
                                '/assets/images/products/electronicSafes/1_2.png',
                                '/assets/images/products/electronicSafes/1_3.png',
                                '/assets/images/products/electronicSafes/1_4.png',
                                '/assets/images/products/electronicSafes/1_5.png',
                                '/assets/images/products/electronicSafes/1_6.png',
                                '/assets/images/products/electronicSafes/1_7.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicSafes/1_1.png',
                                '/assets/images/products/electronicSafes/1_2.png',
                                '/assets/images/products/electronicSafes/1_3.png',
                                '/assets/images/products/electronicSafes/1_4.png',
                                '/assets/images/products/electronicSafes/1_5.png',
                                '/assets/images/products/electronicSafes/1_6.png',
                                '/assets/images/products/electronicSafes/1_7.png'
                            ]
                        },
                        description: 'electronicSafe1Description',
                    }, {
                        id: '2',
                        name: 'electronicSafe2',
                        wallpaper: '/assets/images/products/electronicSafes/2_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicSafes/2_1.png',
                                '/assets/images/products/electronicSafes/2_2.png',
                                '/assets/images/products/electronicSafes/2_3.png',
                                '/assets/images/products/electronicSafes/2_4.png',
                                '/assets/images/products/electronicSafes/2_5.png',
                                '/assets/images/products/electronicSafes/2_6.png',
                                '/assets/images/products/electronicSafes/2_7.png',
                                '/assets/images/products/electronicSafes/2_8.png',
                                '/assets/images/products/electronicSafes/2_9.png',
                                '/assets/images/products/electronicSafes/2_10.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicSafes/2_1.png',
                                '/assets/images/products/electronicSafes/2_2.png',
                                '/assets/images/products/electronicSafes/2_3.png',
                                '/assets/images/products/electronicSafes/2_4.png',
                                '/assets/images/products/electronicSafes/2_5.png',
                                '/assets/images/products/electronicSafes/2_6.png',
                                '/assets/images/products/electronicSafes/2_7.png',
                                '/assets/images/products/electronicSafes/2_8.png',
                                '/assets/images/products/electronicSafes/2_9.png',
                                '/assets/images/products/electronicSafes/2_10.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicSafes/2_1.png',
                                '/assets/images/products/electronicSafes/2_2.png',
                                '/assets/images/products/electronicSafes/2_3.png',
                                '/assets/images/products/electronicSafes/2_4.png',
                                '/assets/images/products/electronicSafes/2_5.png',
                                '/assets/images/products/electronicSafes/2_6.png',
                                '/assets/images/products/electronicSafes/2_7.png',
                                '/assets/images/products/electronicSafes/2_8.png',
                                '/assets/images/products/electronicSafes/2_9.png',
                                '/assets/images/products/electronicSafes/2_10.png'
                            ]
                        },
                        description: 'electronicSafe2Description',
                    }, {
                        id: '3',
                        name: 'electronicSafe3',
                        wallpaper: '/assets/images/products/electronicSafes/3_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicSafes/3_1.png',
                                '/assets/images/products/electronicSafes/3_2.png',
                                '/assets/images/products/electronicSafes/3_3.png',
                                '/assets/images/products/electronicSafes/3_4.png',
                                '/assets/images/products/electronicSafes/3_5.png',
                                '/assets/images/products/electronicSafes/3_6.png',
                                '/assets/images/products/electronicSafes/3_7.png',
                                '/assets/images/products/electronicSafes/3_8.png',
                                '/assets/images/products/electronicSafes/3_9.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicSafes/3_1.png',
                                '/assets/images/products/electronicSafes/3_2.png',
                                '/assets/images/products/electronicSafes/3_3.png',
                                '/assets/images/products/electronicSafes/3_4.png',
                                '/assets/images/products/electronicSafes/3_5.png',
                                '/assets/images/products/electronicSafes/3_6.png',
                                '/assets/images/products/electronicSafes/3_7.png',
                                '/assets/images/products/electronicSafes/3_8.png',
                                '/assets/images/products/electronicSafes/3_9.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicSafes/3_1.png',
                                '/assets/images/products/electronicSafes/3_2.png',
                                '/assets/images/products/electronicSafes/3_3.png',
                                '/assets/images/products/electronicSafes/3_4.png',
                                '/assets/images/products/electronicSafes/3_5.png',
                                '/assets/images/products/electronicSafes/3_6.png',
                                '/assets/images/products/electronicSafes/3_7.png',
                                '/assets/images/products/electronicSafes/3_8.png',
                                '/assets/images/products/electronicSafes/3_9.png'
                            ]
                        },
                        description: 'electronicSafe3Description',
                    }, {
                        id: '4',
                        name: 'electronicSafe4',
                        wallpaper: '/assets/images/products/electronicSafes/4_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicSafes/4_1.png',
                                '/assets/images/products/electronicSafes/4_2.png',
                                '/assets/images/products/electronicSafes/4_3.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicSafes/4_1.png',
                                '/assets/images/products/electronicSafes/4_2.png',
                                '/assets/images/products/electronicSafes/4_3.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicSafes/4_1.png',
                                '/assets/images/products/electronicSafes/4_2.png',
                                '/assets/images/products/electronicSafes/4_3.png'
                            ]
                        },
                        description: 'electronicSafe4Description',
                    }, {
                        id: '5',
                        name: 'electronicSafe5',
                        wallpaper: '/assets/images/products/electronicSafes/5_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicSafes/5_1.png',
                                '/assets/images/products/electronicSafes/5_2.png',
                                '/assets/images/products/electronicSafes/5_3.png',
                                '/assets/images/products/electronicSafes/5_4.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicSafes/5_1.png',
                                '/assets/images/products/electronicSafes/5_2.png',
                                '/assets/images/products/electronicSafes/5_3.png',
                                '/assets/images/products/electronicSafes/5_4.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicSafes/5_1.png',
                                '/assets/images/products/electronicSafes/5_2.png',
                                '/assets/images/products/electronicSafes/5_3.png',
                                '/assets/images/products/electronicSafes/5_4.png'
                            ]
                        },
                        description: 'electronicSafe5Description',
                    }, {
                        id: '6',
                        name: 'electronicSafe6',
                        wallpaper: '/assets/images/products/electronicSafes/6_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/electronicSafes/6_1.png',
                                '/assets/images/products/electronicSafes/6_2.png',
                                '/assets/images/products/electronicSafes/6_3.png',
                                '/assets/images/products/electronicSafes/6_4.png'
                            ],
                            en_us: [
                                '/assets/images/products/electronicSafes/6_1.png',
                                '/assets/images/products/electronicSafes/6_2.png',
                                '/assets/images/products/electronicSafes/6_3.png',
                                '/assets/images/products/electronicSafes/6_4.png'
                            ],
                            es_es: [
                                '/assets/images/products/electronicSafes/6_1.png',
                                '/assets/images/products/electronicSafes/6_2.png',
                                '/assets/images/products/electronicSafes/6_3.png',
                                '/assets/images/products/electronicSafes/6_4.png'
                            ]
                        },
                        description: 'electronicSafe6Description',
                    }
                ]
            }, {
                name: 'energySavers',
                icon: '/assets/images/products/energySavers/icon.png',
                image: '/assets/images/products/energySavers/wallpaper.png',
                description: 'energySaversDescription',
                homeDescription: 'energySaversHomeDescription',
                products: [
                    {
                        id: '1',
                        name: 'energySaver1',
                        wallpaper: '/assets/images/products/energySavers/1_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/1_1.png',
                                '/assets/images/products/energySavers/1_2.png',
                                '/assets/images/products/energySavers/1_3.png'
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/1_1.png',
                                '/assets/images/products/energySavers/1_2.png',
                                '/assets/images/products/energySavers/1_3.png'
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/1_1.png',
                                '/assets/images/products/energySavers/1_2.png',
                                '/assets/images/products/energySavers/1_3.png'
                            ]
                        },
                        description: 'energySaver1Description',
                    }, {
                        id: '2',
                        name: 'energySaver2',
                        wallpaper: '/assets/images/products/energySavers/2_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/2_1.png',
                                '/assets/images/products/energySavers/2_2.png',
                                '/assets/images/products/energySavers/2_3.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/2_1.png',
                                '/assets/images/products/energySavers/2_2.png',
                                '/assets/images/products/energySavers/2_3.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/2_1.png',
                                '/assets/images/products/energySavers/2_2.png',
                                '/assets/images/products/energySavers/2_3.png',
                            ]
                        },
                        description: 'energySaver2Description',
                    }, {
                        id: '3',
                        name: 'energySaver3',
                        wallpaper: '/assets/images/products/energySavers/3_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/3_1.png',
                                '/assets/images/products/energySavers/3_2.png',
                                '/assets/images/products/energySavers/3_3.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/3_1.png',
                                '/assets/images/products/energySavers/3_2.png',
                                '/assets/images/products/energySavers/3_3.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/3_1.png',
                                '/assets/images/products/energySavers/3_2.png',
                                '/assets/images/products/energySavers/3_3.png',
                            ]
                        },
                        description: 'energySaver3Description',
                    }, {
                        id: '4',
                        name: 'energySaver4',
                        wallpaper: '/assets/images/products/energySavers/4_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/4_1.png',
                                '/assets/images/products/energySavers/4_2.png',
                                '/assets/images/products/energySavers/4_3.png',
                                '/assets/images/products/energySavers/4_4.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/4_1.png',
                                '/assets/images/products/energySavers/4_2.png',
                                '/assets/images/products/energySavers/4_3.png',
                                '/assets/images/products/energySavers/4_4.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/4_1.png',
                                '/assets/images/products/energySavers/4_2.png',
                                '/assets/images/products/energySavers/4_3.png',
                                '/assets/images/products/energySavers/4_4.png',
                            ]
                        },
                        description: 'energySaver4Description',
                    }, {
                        id: '5',
                        name: 'energySaver5',
                        wallpaper: '/assets/images/products/energySavers/5_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/5_1.png',
                                '/assets/images/products/energySavers/5_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/5_1.png',
                                '/assets/images/products/energySavers/5_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/5_1.png',
                                '/assets/images/products/energySavers/5_2.png',
                            ]
                        },
                        description: 'energySaver5Description',
                    }, {
                        id: '6',
                        name: 'energySaver6',
                        wallpaper: '/assets/images/products/energySavers/6_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/6_1.png',
                                '/assets/images/products/energySavers/6_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/6_1.png',
                                '/assets/images/products/energySavers/6_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/6_1.png',
                                '/assets/images/products/energySavers/6_2.png',
                            ]
                        },
                        description: 'energySaver6Description',
                    }, {
                        id: '7',
                        name: 'energySaver7',
                        wallpaper: '/assets/images/products/energySavers/7_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/7_1.png',
                                '/assets/images/products/energySavers/7_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/7_1.png',
                                '/assets/images/products/energySavers/7_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/7_1.png',
                                '/assets/images/products/energySavers/7_2.png',
                            ]
                        },
                        description: 'energySaver7Description',
                    }, {
                        id: '8',
                        name: 'energySaver8',
                        wallpaper: '/assets/images/products/energySavers/8_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/8_1.png',
                                '/assets/images/products/energySavers/8_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/8_1.png',
                                '/assets/images/products/energySavers/8_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/8_1.png',
                                '/assets/images/products/energySavers/8_2.png',
                            ]
                        },
                        description: 'energySaver8Description',
                    }, {
                        id: '9',
                        name: 'energySaver9',
                        wallpaper: '/assets/images/products/energySavers/9_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/9_1.png',
                                '/assets/images/products/energySavers/9_2.png',
                                '/assets/images/products/energySavers/9_3.png',
                                '/assets/images/products/energySavers/9_4.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/9_1.png',
                                '/assets/images/products/energySavers/9_2.png',
                                '/assets/images/products/energySavers/9_3.png',
                                '/assets/images/products/energySavers/9_4.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/9_1.png',
                                '/assets/images/products/energySavers/9_2.png',
                                '/assets/images/products/energySavers/9_3.png',
                                '/assets/images/products/energySavers/9_4.png',
                            ]
                        },
                        description: 'energySaver9Description',
                    }, {
                        id: '10',
                        name: 'energySaver10',
                        wallpaper: '/assets/images/products/energySavers/10_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/10_1.png',
                                '/assets/images/products/energySavers/10_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/10_1.png',
                                '/assets/images/products/energySavers/10_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/10_1.png',
                                '/assets/images/products/energySavers/10_2.png',
                            ]
                        },
                        description: 'energySaver10Description',
                    }, {
                        id: '11',
                        name: 'energySaver11',
                        wallpaper: '/assets/images/products/energySavers/11_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/11_1.png',
                                '/assets/images/products/energySavers/11_2.png',
                                '/assets/images/products/energySavers/11_3.png',
                                '/assets/images/products/energySavers/11_4.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/11_1.png',
                                '/assets/images/products/energySavers/11_2.png',
                                '/assets/images/products/energySavers/11_3.png',
                                '/assets/images/products/energySavers/11_4.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/11_1.png',
                                '/assets/images/products/energySavers/11_2.png',
                                '/assets/images/products/energySavers/11_3.png',
                                '/assets/images/products/energySavers/11_4.png',
                            ]
                        },
                        description: 'energySaver11Description',
                    }, {
                        id: '12',
                        name: 'energySaver12',
                        wallpaper: '/assets/images/products/energySavers/12_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/energySavers/12_1.png',
                                '/assets/images/products/energySavers/12_2.png',
                                '/assets/images/products/energySavers/12_3.png',
                                '/assets/images/products/energySavers/12_4.png',
                            ],
                            en_us: [
                                '/assets/images/products/energySavers/12_1.png',
                                '/assets/images/products/energySavers/12_2.png',
                                '/assets/images/products/energySavers/12_3.png',
                                '/assets/images/products/energySavers/12_4.png',
                            ],
                            es_es: [
                                '/assets/images/products/energySavers/12_1.png',
                                '/assets/images/products/energySavers/12_2.png',
                                '/assets/images/products/energySavers/12_3.png',
                                '/assets/images/products/energySavers/12_4.png',
                            ]
                        },
                        description: 'energySaver12Description',
                    }
                ]
            }, {
                name: 'accessories',
                icon: '/assets/images/products/accessories/icon.png',
                image: '/assets/images/products/accessories/wallpaper.png',
                description: 'accessoriesDescription',
                homeDescription: 'accessoriesHomeDescription',
                products: [
                    {
                        id: '1',
                        name: 'accessory1',
                        wallpaper: '/assets/images/products/accessories/1_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/1_1.png',
                                '/assets/images/products/accessories/1_2.png',
                                '/assets/images/products/accessories/1_3.png'
                            ],
                            en_us: [
                                '/assets/images/products/accessories/1_1.png',
                                '/assets/images/products/accessories/1_2.png',
                                '/assets/images/products/accessories/1_3.png'
                            ],
                            es_es: [
                                '/assets/images/products/accessories/1_1.png',
                                '/assets/images/products/accessories/1_2.png',
                                '/assets/images/products/accessories/1_3.png'
                            ]
                        },
                        description: 'accessory1Description',
                    }, {
                        id: '2',
                        name: 'accessory2',
                        wallpaper: '/assets/images/products/accessories/2_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/2_1.png',
                                '/assets/images/products/accessories/2_2.png',
                                '/assets/images/products/accessories/2_3.png',
                                '/assets/images/products/accessories/2_4.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/2_1.png',
                                '/assets/images/products/accessories/2_2.png',
                                '/assets/images/products/accessories/2_3.png',
                                '/assets/images/products/accessories/2_4.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/2_1.png',
                                '/assets/images/products/accessories/2_2.png',
                                '/assets/images/products/accessories/2_3.png',
                                '/assets/images/products/accessories/2_4.png',
                            ]
                        },
                        description: 'accessory2Description',
                    }, {
                        id: '3',
                        name: 'accessory3',
                        wallpaper: '/assets/images/products/accessories/3_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/3_1.png',
                                '/assets/images/products/accessories/3_2.png',
                                '/assets/images/products/accessories/3_3.png',
                                '/assets/images/products/accessories/3_4.png',
                                '/assets/images/products/accessories/3_5.png',
                                '/assets/images/products/accessories/3_6.png',
                                '/assets/images/products/accessories/3_7.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/3_1.png',
                                '/assets/images/products/accessories/3_2.png',
                                '/assets/images/products/accessories/3_3.png',
                                '/assets/images/products/accessories/3_4.png',
                                '/assets/images/products/accessories/3_5.png',
                                '/assets/images/products/accessories/3_6.png',
                                '/assets/images/products/accessories/3_7.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/3_1.png',
                                '/assets/images/products/accessories/3_2.png',
                                '/assets/images/products/accessories/3_3.png',
                                '/assets/images/products/accessories/3_4.png',
                                '/assets/images/products/accessories/3_5.png',
                                '/assets/images/products/accessories/3_6.png',
                                '/assets/images/products/accessories/3_7.png',
                            ]
                        },
                        description: 'accessory3Description',
                    }, {
                        id: '4',
                        name: 'accessory4',
                        wallpaper: '/assets/images/products/accessories/4_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/4_1.png',
                                '/assets/images/products/accessories/4_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/4_1.png',
                                '/assets/images/products/accessories/4_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/4_1.png',
                                '/assets/images/products/accessories/4_2.png',
                            ]
                        },
                        description: 'accessory4Description',
                    }, {
                        id: '5',
                        name: 'accessory5',
                        wallpaper: '/assets/images/products/accessories/5_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/5_1.png',
                                '/assets/images/products/accessories/5_2.png',
                                '/assets/images/products/accessories/5_3.png',
                                '/assets/images/products/accessories/5_4.png',
                                '/assets/images/products/accessories/5_5.png',
                                '/assets/images/products/accessories/5_6.png',
                                '/assets/images/products/accessories/5_7.png',
                                '/assets/images/products/accessories/5_8.png',
                                '/assets/images/products/accessories/5_9.png',
                                '/assets/images/products/accessories/5_10.png',
                                '/assets/images/products/accessories/5_11.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/5_1.png',
                                '/assets/images/products/accessories/5_2.png',
                                '/assets/images/products/accessories/5_3.png',
                                '/assets/images/products/accessories/5_4.png',
                                '/assets/images/products/accessories/5_5.png',
                                '/assets/images/products/accessories/5_6.png',
                                '/assets/images/products/accessories/5_7.png',
                                '/assets/images/products/accessories/5_8.png',
                                '/assets/images/products/accessories/5_9.png',
                                '/assets/images/products/accessories/5_10.png',
                                '/assets/images/products/accessories/5_11.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/5_1.png',
                                '/assets/images/products/accessories/5_2.png',
                                '/assets/images/products/accessories/5_3.png',
                                '/assets/images/products/accessories/5_4.png',
                                '/assets/images/products/accessories/5_5.png',
                                '/assets/images/products/accessories/5_6.png',
                                '/assets/images/products/accessories/5_7.png',
                                '/assets/images/products/accessories/5_8.png',
                                '/assets/images/products/accessories/5_9.png',
                                '/assets/images/products/accessories/5_10.png',
                                '/assets/images/products/accessories/5_11.png',
                            ]
                        },
                        description: 'accessory5Description',
                    }, {
                        id: '6',
                        name: 'accessory6',
                        wallpaper: '/assets/images/products/accessories/6_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/6_1.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/6_1.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/6_1.png',
                            ]
                        },
                        description: 'accessory6Description',
                    }, {
                        id: '7',
                        name: 'accessory7',
                        wallpaper: '/assets/images/products/accessories/7_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/7_1.png',
                                '/assets/images/products/accessories/7_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/7_1.png',
                                '/assets/images/products/accessories/7_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/7_1.png',
                                '/assets/images/products/accessories/7_2.png',
                            ]
                        },
                        description: 'accessory7Description',
                    }, {
                        id: '8',
                        name: 'accessory8',
                        wallpaper: '/assets/images/products/accessories/8_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/8_1.png',
                                '/assets/images/products/accessories/8_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/8_1.png',
                                '/assets/images/products/accessories/8_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/8_1.png',
                                '/assets/images/products/accessories/8_2.png',
                            ]
                        },
                        description: 'accessory8Description',
                    }, {
                        id: '9',
                        name: 'accessory9',
                        wallpaper: '/assets/images/products/accessories/9_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/9_1.png',
                                '/assets/images/products/accessories/9_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/9_1.png',
                                '/assets/images/products/accessories/9_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/9_1.png',
                                '/assets/images/products/accessories/9_2.png',
                            ]
                        },
                        description: 'accessory9Description',
                    }, {
                        id: '10',
                        name: 'accessory10',
                        wallpaper: '/assets/images/products/accessories/10_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/10_1.png',
                                '/assets/images/products/accessories/10_2.png',
                                '/assets/images/products/accessories/10_3.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/10_1.png',
                                '/assets/images/products/accessories/10_2.png',
                                '/assets/images/products/accessories/10_3.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/10_1.png',
                                '/assets/images/products/accessories/10_2.png',
                                '/assets/images/products/accessories/10_3.png',
                            ]
                        },
                        description: 'accessory10Description',
                    }, {
                        id: '11',
                        name: 'accessory11',
                        wallpaper: '/assets/images/products/accessories/11_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/11_1.png',
                                '/assets/images/products/accessories/11_2.png',
                                '/assets/images/products/accessories/11_3.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/11_1.png',
                                '/assets/images/products/accessories/11_2.png',
                                '/assets/images/products/accessories/11_3.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/11_1.png',
                                '/assets/images/products/accessories/11_2.png',
                                '/assets/images/products/accessories/11_3.png',
                            ]
                        },
                        description: 'accessory11Description',
                    }, {
                        id: '12',
                        name: 'accessory12',
                        wallpaper: '/assets/images/products/accessories/12_1.png',
                        images: {
                            pt_br: [
                                '/assets/images/products/accessories/12_1.png',
                                '/assets/images/products/accessories/12_2.png',
                            ],
                            en_us: [
                                '/assets/images/products/accessories/12_1.png',
                                '/assets/images/products/accessories/12_2.png',
                            ],
                            es_es: [
                                '/assets/images/products/accessories/12_1.png',
                                '/assets/images/products/accessories/12_2.png',
                            ]
                        },
                        description: 'accessory12Description',
                    }
                ]
            }
        ]
    },
    services: {
        title: 'services',
        subtitle: 'servicesSubtitle',
        description: 'servicesDescription',
        wallpaper: '/assets/images/services/wallpaper.png',
        items: [
            {
                id: '1',
                name: 'systemsRestructuring',
                wallpaper: '/assets/images/services/systemsRestructuring/wallpaper.png',
                homeDescription: 'systemsRestructuringHomeDescription',
                description: 'systemsRestructuringDescription',
                images: {
                    pt_br: [
                        '/assets/images/services/systemsRestructuring/1.png'
                    ],
                    en_us: [
                        '/assets/images/services/systemsRestructuring/1.png'
                    ], 
                    es_es: [
                        '/assets/images/services/systemsRestructuring/1.png'
                    ]
                }
            }, {
                id: '2',
                name: 'recyclingTrainings',
                wallpaper: '/assets/images/services/recyclingTrainings/wallpaper.png',
                homeDescription: 'recyclingTrainingsHomeDescription',
                description: 'recyclingTrainingsDescription',
                images: {
                    pt_br: [
                        '/assets/images/services/recyclingTrainings/1.png'
                    ],
                    en_us: [
                        '/assets/images/services/recyclingTrainings/1.png'
                    ], 
                    es_es: [
                        '/assets/images/services/recyclingTrainings/1.png'
                    ]
                }
            }, {
                id: '3',
                name: 'preventiveCorrectiveMaintenance',
                wallpaper: '/assets/images/services/preventiveCorrectiveMaintenance/wallpaper.png',
                homeDescription: 'preventiveCorrectiveMaintenanceHomeDescription',
                description: 'preventiveCorrectiveMaintenanceDescription',
                images: {
                    pt_br: [
                        '/assets/images/services/preventiveCorrectiveMaintenance/1.png'
                    ],
                    en_us: [
                        '/assets/images/services/preventiveCorrectiveMaintenance/1.png'
                    ], 
                    es_es: [
                        '/assets/images/services/preventiveCorrectiveMaintenance/1.png'
                    ]
                }
            }, {
                id: '4',
                name: 'installationPeripheralsLocks',
                wallpaper: '/assets/images/services/installationPeripheralsLocks/wallpaper.png',
                homeDescription: 'installationPeripheralsLocksHomeDescription',
                description: 'installationPeripheralsLocksDescription',
                images: {
                    pt_br: [
                        '/assets/images/services/installationPeripheralsLocks/1.png'
                    ],
                    en_us: [
                        '/assets/images/services/installationPeripheralsLocks/1.png'
                    ], 
                    es_es: [
                        '/assets/images/services/installationPeripheralsLocks/1.png'
                    ]
                }
            }, {
                id: '5',
                name: 'specializedTechnicalTeam',
                wallpaper: '/assets/images/services/specializedTechnicalTeam/wallpaper.png',
                homeDescription: 'specializedTechnicalTeamHomeDescription',
                description: 'specializedTechnicalTeamDescription',
                images: {
                    pt_br: [
                        '/assets/images/services/specializedTechnicalTeam/1.png'
                    ],
                    en_us: [
                        '/assets/images/services/specializedTechnicalTeam/1.png'
                    ], 
                    es_es: [
                        '/assets/images/services/specializedTechnicalTeam/1.png'
                    ]
                }
            }, {
                id: '6',
                name: '_24HourTechnicalAssistance',
                wallpaper: '/assets/images/services/24HourTechnicalAssistance/wallpaper.png',
                homeDescription: '_24HourTechnicalAssistanceHomeDescription',
                description: '_24HourTechnicalAssistanceDescription',
                images: {
                    pt_br: [
                        '/assets/images/services/24HourTechnicalAssistance/1.png'
                    ],
                    en_us: [
                        '/assets/images/services/24HourTechnicalAssistance/1.png'
                    ], 
                    es_es: [
                        '/assets/images/services/24HourTechnicalAssistance/1.png'
                    ]
                }
            }
        ]
    },
    about: {
        title: 'aboutUs',
        subtitle: 'aboutUsDescription',
        wallpaper: '/assets/images/about/wallpaper.png',
        homeWallpaper: '/assets/images/about/homeWallpaper.png',
        shortDescription: 'aboutShortDescription',
        video: 'assets/videos/about/video.mp4',
        stamp: 'assets/images/about/stamp.png',
        images: [
            '/assets/images/about/1.png'
        ]
    },
    sustainability: {
        title: 'sustainability',
        subtitle: 'sustainabilityDescription',
        wallpaper: '/assets/images/sustainability/wallpaper.png',
        pdf: 'assets/documents/sustainability/esg.pdf',
        video: 'assets/videos/sustainability/video.mp4',
        images: {
            pt_br: [
                '/assets/images/sustainability/pt_br/1.png',
                '/assets/images/sustainability/pt_br/2.png',
                '/assets/images/sustainability/pt_br/3.png',
                '/assets/images/sustainability/pt_br/4.png',
                '/assets/images/sustainability/pt_br/5.png',
                '/assets/images/sustainability/pt_br/6.png',
                '/assets/images/sustainability/pt_br/7.png',
                '/assets/images/sustainability/pt_br/8.png',
                '/assets/images/sustainability/pt_br/9.png',
                '/assets/images/sustainability/pt_br/10.png',
                '/assets/images/sustainability/pt_br/11.png',
                '/assets/images/sustainability/pt_br/12.png'
            ],
            en_us: [
                '/assets/images/sustainability/en_us/1.png',
                '/assets/images/sustainability/en_us/2.png',
                '/assets/images/sustainability/en_us/3.png',
                '/assets/images/sustainability/en_us/4.png',
                '/assets/images/sustainability/en_us/5.png',
                '/assets/images/sustainability/en_us/6.png',
                '/assets/images/sustainability/en_us/7.png',
                '/assets/images/sustainability/en_us/8.png',
                '/assets/images/sustainability/en_us/9.png',
                '/assets/images/sustainability/en_us/10.png',
                '/assets/images/sustainability/en_us/11.png',
                '/assets/images/sustainability/en_us/12.png'
            ],
            es_es: [
                '/assets/images/sustainability/es_es/1.png',
                '/assets/images/sustainability/es_es/2.png',
                '/assets/images/sustainability/es_es/3.png',
                '/assets/images/sustainability/es_es/4.png',
                '/assets/images/sustainability/es_es/5.png',
                '/assets/images/sustainability/es_es/6.png',
                '/assets/images/sustainability/es_es/7.png',
                '/assets/images/sustainability/es_es/8.png',
                '/assets/images/sustainability/es_es/9.png',
                '/assets/images/sustainability/es_es/10.png',
                '/assets/images/sustainability/es_es/11.png',
                '/assets/images/sustainability/es_es/12.png'
            ]
        }
    },
    contact: {
        title: 'contact',
        subtitle: 'contactDescription',
        wallpaper: '/assets/images/contact/wallpaper.png',
        subjects: ['informations', 'sales', 'technicalAssistance']
    },
    footer: {
        wallpaper: '/assets/images/footer/wallpaper.png',
    },
    socialMedias: [
        {
            url: undefined,
            Icon: WhatsApp
        }, {
            url: 'https://www.facebook.com/sagasystems/',
            Icon: Facebook
        }, {
            url: 'https://www.youtube.com/@SagaSystemsOficial',
            Icon: YouTube
        }, {
            url: 'https://www.instagram.com/sagasystems/',
            Icon: Instagram
        }, {
            url: 'https://www.linkedin.com/company/saga-systems-brasil/',
            Icon: LinkedIn
        }, {
            url: undefined,
            Icon: Pinterest
        }, {
            url: undefined,
            Icon: Twitter
        }
    ],
    clients: [
        {
            name: 'Hospital Dom Antonio de Alvarenga',
            image: '/assets/images/clients/1.png'
        }, {
            name: 'Hospital Albert Einstein',
            image: '/assets/images/clients/2.png'
        }, {
            name: 'Hospital A. C. Camargo',
            image: '/assets/images/clients/3.png'
        }, {
            name: 'Vogal Luxury Beach Hotel & Spa',
            image: '/assets/images/clients/4.png'
        }, {
            name: 'Vert Hotéis',
            image: '/assets/images/clients/5.png'
        }, {
            name: 'Hospital Vera Cruz Campinas',
            image: '/assets/images/clients/6.png'
        }, {
            name: 'Trip Hotels',
            image: '/assets/images/clients/7.png'
        }, {
            name: 'Transamérica Hospitality Group',
            image: '/assets/images/clients/8.png'
        }, {
            name: 'Sesc',
            image: '/assets/images/clients/9.png'
        }, {
            name: 'Rede D`Or São Luiz',
            image: '/assets/images/clients/10.png'
        }, {
            name: 'São Joaquim Hospital e Maternidade',
            image: '/assets/images/clients/11.png'
        }, {
            name: 'São Cristóvão Saúde',
            image: '/assets/images/clients/12.png'
        }, {
            name: 'San Raphael Hotel',
            image: '/assets/images/clients/13.png'
        }, {
            name: 'Radisson Aracaju',
            image: '/assets/images/clients/14.png'
        }, {
            name: 'Pratagy Beach All-Inclusive Resort',
            image: '/assets/images/clients/15.png'
        }, {
            name: 'Vale Encantado Hotel Fazenda e Pousada',
            image: '/assets/images/clients/16.png'
        }, {
            name: 'Paulista Wall Street Suites',
            image: '/assets/images/clients/17.png'
        }, {
            name: 'Parador da Figueira Pousada',
            image: '/assets/images/clients/18.png'
        }, {
            name: 'Oceani Beach Park Hotel',
            image: '/assets/images/clients/19.png'
        }, {
            name: 'Hospital Nove de Julho',
            image: '/assets/images/clients/20.png'
        }, {
            name: 'Meliã Hotels International',
            image: '/assets/images/clients/21.png'
        }, {
            name: 'Maceió Mar Hotel',
            image: '/assets/images/clients/22.png'
        }, {
            name: 'Hospital Leforte',
            image: '/assets/images/clients/23.png'
        }, {
            name: 'Kuara Hotel',
            image: '/assets/images/clients/24.png'
        }, {
            name: 'Kembali Hotel',
            image: '/assets/images/clients/25.png'
        }, {
            name: 'InterCity Hotéis Inteligentes',
            image: '/assets/images/clients/26.png'
        }, {
            name: 'Iloa Resort',
            image: '/assets/images/clients/27.png'
        }, {
            name: 'Hospital IFOR',
            image: '/assets/images/clients/28.png'
        }, {
            name: 'Hotel Manaíra',
            image: '/assets/images/clients/29.png'
        }, {
            name: 'EZ Hotéis',
            image: '/assets/images/clients/30.png'
        }, {
            name: 'Hotel Coquille',
            image: '/assets/images/clients/31.png'
        }, {
            name: 'Grupo Nobile',
            image: '/assets/images/clients/32.png'
        }, {
            name: 'Estanplaza Hotels',
            image: '/assets/images/clients/33.png'
        }, {
            name: 'Enotel Hotels & Resorts',
            image: '/assets/images/clients/34.png'
        }, {
            name: 'DPNY Beach Hotel',
            image: '/assets/images/clients/35.png'
        }, {
            name: 'Casa Grande Hotel, Resort & Spa',
            image: '/assets/images/clients/36.png'
        }, {
            name: 'Paraíso dos Colibris',
            image: '/assets/images/clients/37.png'
        }, {
            name: 'Bourbon Hotéis & Resorts',
            image: '/assets/images/clients/38.png'
        }, {
            name: 'Bonito Ecotel',
            image: '/assets/images/clients/39.png'
        }, {
            name: 'Brazil Hospitality Group',
            image: '/assets/images/clients/40.png'
        }, {
            name: 'Beach Park',
            image: '/assets/images/clients/41.png'
        }, {
            name: 'Atlantica Hotels',
            image: '/assets/images/clients/42.png'
        }, {
            name: 'Aram Hotéis',
            image: '/assets/images/clients/43.png'
        }, {
            name: 'Araçatuba Plaza Hotel',
            image: '/assets/images/clients/44.png'
        }, {
            name: 'Hospital Ana Costa',
            image: '/assets/images/clients/45.png'
        },
    ],
    testimonials: [
        {
            client: 'Hilton Garden Inn Santo André',
            person: 'Sra. Isabela Vieira',
            avatar: '/assets/images/testimonials/1.png',
            message: 'testimonial1Message'
        }, {
            client: 'Palace Hotel Pradópolis',
            avatar: '/assets/images/testimonials/2.png',
            message: 'testimonial2Message'
        }, {
            client: 'Hotel Coquille',
            avatar: '/assets/images/testimonials/3.png',
            message: 'testimonial3Message'
        }, {
            client: 'Hotel Intercity Ribeirão Preto',
            person: 'Sr. Ignacio Sasias - Gerente Geral',
            avatar: '/assets/images/testimonials/4.png',
            message: 'testimonial4Message'
        }, {
            client: 'Hotel Tryp Nações Unidas',
            avatar: '/assets/images/testimonials/5.png',
            message: 'testimonial5Message'
        }
    ],
    employees: [
        {
            name: 'Antônio Rossi',
            phone: '(11) 99125-9759',
            emails: ['rrx.representacoes@gmail.com'],
            position: 'salesRepresentative',
            location: 'São Paulo',
            avatar: '/assets/images/employees/5.png'
        }, {
            name: 'Cláudia Pinto',
            phone: '(81) 99707-2424',
            emails: ['claudia.pinto@sagasystems.com.br'],
            position: 'salesRepresentative',
            location: 'Alagoas e Pernambuco',
            avatar: '/assets/images/employees/6.png'
        }, {
            name: 'Fábio Piovesan',
            phone: '(54) 99923-8787',
            emails: ['fabio@biosantel.com.br'],
            position: 'salesRepresentative',
            location: 'Rio Grande do Sul',
            avatar: '/assets/images/employees/17.png'
        }, {
            name: 'Ione Neves',
            phone: '(67) 99693-7779',
            emails: ['inb.representacoes@gmail.com'],
            position: 'salesRepresentative',
            location: 'Mato Grosso e Mato Grosso do Sul',
            avatar: '/assets/images/employees/8.png'
        }, {
            name: 'Luiz Augusto',
            phone: '(27) 99816-5119',
            emails: ['solin@solin.rep.br'],
            position: 'salesRepresentative',
            location: 'Espírito Santo',
            avatar: '/assets/images/employees/9.png'
        }, {
            name: 'Luiz Navarro',
            phone: '(11) 97656-0114',
            emails: ['comercial1@sagasystems.com.br'],
            position: 'salesRepresentative',
            location: 'São Paulo',
            avatar: '/assets/images/employees/10.png'
        }, {
            name: 'Marcos Bomfim',
            phone: '(71) 99363-4373',
            emails: ['marcos.bomfim@sagasystems.com.br'],
            position: 'salesRepresentative',
            location: 'Bahia e Sergipe',
            avatar: '/assets/images/employees/11.png'
        }, {
            name: 'Monica Barranco',
            phone: '(11) 98510-3602',
            emails: ['monica.barranco@sagasystems.com.br'],
            position: 'salesRepresentative',
            location: 'São Paulo',
            avatar: '/assets/images/employees/16.png'
        }, {
            name: 'Natália M. Mangas',
            phone: '+56 98272-8539',
            emails: ['gerencia@sagasystemschile.com', 'ventasyservicio@sagasystemschile.com'],
            position: 'sagaSystems',
            location: 'Santiago (Chile)',
            avatar: '/assets/images/employees/19.png'
        }, {
            name: 'Ricardo Gabriel',
            phone: '(92) 98112-8833',
            emails: ['ricardogabriel83@gmail.com'],
            position: 'salesRepresentative',
            location: 'Amazonas',
            avatar: '/assets/images/employees/12.png'
        }, {
            name: 'Roberto C. Germano',
            phone: '(61) 98122-0034',
            emails: ['roberto@lgerep.com.br'],
            position: 'salesRepresentative',
            location: 'Distrito Federal',
            avatar: '/assets/images/employees/18.png'
        }, {
            name: 'Romário Linhares',
            phone: '(86) 98841-2190',
            emails: ['romariolinharesla@gmail.com'],
            position: 'salesRepresentative',
            location: 'Piauí',
            avatar: '/assets/images/employees/2.png'
        }, {
            name: 'Tarcísio Paiva',
            phone: '(83) 98829-9403',
            emails: ['tarcisiorep@hotmail.com'],
            position: 'salesRepresentative',
            location: 'Paraíba',
            avatar: '/assets/images/employees/3.png'
        }, {
            name: 'Thiago Dangió',
            phone: '(17) 99219-5017',
            emails: ['thiagodangio@gmail.com'],
            position: 'salesRepresentative',
            location: 'São José do Rio Preto (SP)',
            avatar: '/assets/images/employees/7.png'
        }, {
            name: 'Valmir Dantas',
            phone: '(84) 99422-2524',
            emails: ['lima-valmir@uol.com.br'],
            position: 'salesRepresentative',
            location: 'Rio Grande do Norte',
            avatar: '/assets/images/employees/4.png'
        }, {
            name: 'Vinícius Natividade',
            phone: '(71) 98828-3310',
            emails: ['natividaderepresentacoes@gmail.com'],
            position: 'salesRepresentative',
            location: 'Bahia',
            avatar: '/assets/images/employees/1.png'
        }
    ]
};

const systemNameFormatted = DefaultConstants.systemName.toLowerCase().replace(/ /g, '');


const StorageConstants = {
    languageStorageName: `${systemNameFormatted}_currentlanguage`,
}

const KeyConstants = {
    privateKey: process.env.REACT_APP_PRIVATE_KEY || `${systemNameFormatted}_privatekey`
}


export {
    StorageConstants,
    KeyConstants
}

export default DefaultConstants;

